/**
 * @flow
 */

import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from 'redux'
import { thunk } from 'redux-thunk'
import { createLogger } from 'redux-logger'
import persistState from 'redux-localstorage'
import reducer from './reducer'

// Define the window augmentation for Redux DevTools
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    store?: any; // Add this to expose store to window
  }
}

const middleware = [thunk]

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger()
  middleware.push(logger)
}

// Use redux devtools extension if available
const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

const enhancer = composeEnhancers(
  applyMiddleware(...middleware),
  persistState(['form', 'progress', 'resumes'], { key: 'makemyresume' }),
)

const store = createStore(reducer, enhancer)

// Expose the store to window for easier access by extensions
if (typeof window !== 'undefined') {
  window.store = store;
}

export default store